var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',{attrs:{"title":"New Category","back":{ name: 'categories' }}},[_c('data-box',{attrs:{"status":false}},[_c('category-form')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }